import { Box, Stack, StackProps } from '@mui/material';

import { default as CloseIcon } from './assets/close.svg?react';
import { default as SonicIcon } from './assets/sonic.svg?react';
import { default as VedaIcon } from '../../../layout/screens/DefaultLayout/components/Header/assets/right-logo.svg?react';
import { LogoWhite } from 'modules/layout/components/Logo/logo-white';

export function Bottom({ sx }: StackProps): JSX.Element {
  return (
    <Stack
      gap={3}
      pt={10}
      pb={4}
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      sx={{
        ...sx,
        flexDirection: {
          xs: 'column',
          sm: 'row',
        },
      }}
    >
      <Box component={LogoWhite} sx={{ height: 32, color: '#b1b1b4' }} />
      <Box
        component={CloseIcon}
        sx={{
          height: 16,
          color: '#b1b1b4',
        }}
      />
      <Box component={SonicIcon} sx={{ height: 32, color: '#b1b1b4' }} />
      <Box
        component={CloseIcon}
        sx={{
          height: 16,
          color: '#b1b1b4',
        }}
      />
      <Box component={VedaIcon} sx={{ height: 20, color: '#b1b1b4' }} />
    </Stack>
  );
}
